/** Shared module grade select options (1.0–4.0 step 0.1, plus 5.0 fail). */

export const MODULE_GRADE_OPTIONS = [
  ...Array.from({ length: 31 }, (_, i) => {
    const value = (1 + i * 0.1).toFixed(1);
    return { label: value, value };
  }),
  { label: '5.0', value: '5.0' },
] as const;
